function returnValue(v) {
    return v
}

export { returnValue }
